import { useCallback, useState } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { PageShell } from '~/components/layout';
import {
  CtaBanner,
  DownloadQr,
  FeatureBlock,
  Hero,
  MarketersAgencyApplication,
  MarketersCardPanel,
  MarketersOfferBanner,
  MarketersOfferModal,
  MarketersUsdAccount,
  TestimonialGrid,
  TextSection,
} from '~/components/sections';
import {
  marketersCard,
  marketersCardEveryday,
  marketersHero,
  marketersTestimonials,
  marketersTrustedBySection,
} from '~/content/marketers';
import { pageHeadMeta } from '~/lib/seo';
import heroCss from '~/styles/hero.css?inline';

export const Route = createFileRoute('/cards_/marketers')({
  head: () =>
    pageHeadMeta({
      title: 'The nsave Card for Marketing Spend',
      description:
        'Pay for Google, Meta and the rest of your marketing stack in USD with the nsave card. Get 10% cashback, up to $100, on your first Google or Meta ad.',
      path: '/cards/marketers',
      inlineStyles: [heroCss],
    }),
  component: MarketersPage,
});

function MarketersPage() {
  const [offerOpen, setOfferOpen] = useState(false);
  const closeOffer = useCallback(() => setOfferOpen(false), []);

  return (
    <PageShell>
      <Hero
        content={marketersHero}
        statsSlot={
          <MarketersOfferBanner
            onLearnMore={() => setOfferOpen(true)}
            className="mt-[92px] md:mt-[124px]"
          />
        }
      />
      <TextSection content={marketersTrustedBySection} />
      <MarketersUsdAccount />
      <FeatureBlock
        content={marketersCard}
        imagePosition="left"
        media={<MarketersCardPanel />}
        sectionClassName="!pb-[10px] md:!pt-[120px] max-lg:mb-16"
      />
      <FeatureBlock
        content={marketersCardEveryday}
        imagePosition="right"
        ctaSlot={<DownloadQr />}
        sectionClassName="!py-[10px]"
      />
      <MarketersAgencyApplication />
      <TestimonialGrid content={marketersTestimonials} />
      <CtaBanner />
      {/* Page level rather than inside the banner: the hero is its own stacking context. */}
      <MarketersOfferModal open={offerOpen} onClose={closeOffer} />
    </PageShell>
  );
}
